import AddIcon from "@mui/icons-material/Add";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import HelpIcon from "@mui/icons-material/Help";
import { Chip, Divider, Fab, IconButton, Stack, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Getrequestcall } from "../../request/Getrequest";
import { Postrequestcall } from "../../request/Postrequest";
import { BIGrey, BILightGrey } from "../../assets/helpers";
import Loader from "../../common/Loader";
import {
  DELETE_CLIENT_TIMESHEETS,
  FETCH_CLIENT_TIMESHEET_JOBS_V2,
  FETCH_CLIENT_TIMESHEETS_TO_APPROVE,
  GET_CLIENT_TIMESHEET_DASHBOARD
} from "../../constant/Apipath";
import TabsComponent from "../component/TabsComponent";
import ClientTimesheetAddModal from "./clientTimesheetAdd/ClientTimesheetAddModal";
import CrewTimesheetEmployeeClockInClockOut from "./clientTimesheetAdd/CrewTimesheetEmployeeClockInClockOut";
import { CrewTimesheetForemanEntry } from "./clientTimesheetAdd/CrewTimesheetForemanEntry";
import ConfirmModal from "./promptModal/ConfirmModal";
import DeletConfirmModal from "./promptModal/DeletConfirmModal";
import ReviewTimeSheet from "./reviewTimesheet/ReviewTimesheet";
import ClientTimesheetViewIndividual, {
  formatTime
} from "./ViewTimesheet/ClientTimesheetViewIndividual";
import ClientViewCrewTimesheetForeman from "./ViewTimesheet/ClientViewCrewTimesheetForeman";
import ClientViewEmployeeTimeSheet from "./ViewTimesheet/ClientViewEmployeeTimeSheet";
import ClientViewGeneratedTimesheet from "./ViewTimesheet/ClientViewGeneratedTimesheet";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import CrewTemplateForm from "./crewTemplateForm/CrewTemplateForm";

const COLORS = {
  GREEN_LIGHT: "#c6d9bb",
  RED_LIGHT: "#f5a9a9",
  LIGHT_YELLOW: "#FFEEBF",
  GREEN_DARK_TEXT: "#215112",
  YELLOW_DARK_TEXT: "#684f0a",
  RED_DARK_TEXT: "#9b2020"
};

const TIMESHEET_TYPES = {
  CREW: "Crew",
  CREW_CLOCK_IN: "Crew Clock In",
  INDIVIDUAL: "Individual",
  INDIVIDUAL_CLOCK_IN: "Individual Clock In"
};

const TIMESHEET_STATUS = {
  IN_REVIEW: "In Review",
  REJECTED: "Rejected",
  APPROVED: "Approved",
  IN_PROGRESS: "In Progress"
};

const ClientTimesheets = () => {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const clientAccentColor = selectedClientData?.AccentColor ?? "";
  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;

  const [isLoading, setIsLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState(0);
  const [timesheetList, setTimesheetList] = useState([]);
  const [toApproveTimesheetList, setToApproveTimesheetList] = useState([]);
  const [toApproveCount, setToApproveCount] = useState(0); // implement in future

  // Modal states
  const [showAddClientTimesheetModal, setShowAddClientTimesheetModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [deletConfirmModal, setDeletConfirmModal] = useState(false);
  const [viewClientTimesheetdata, setViewClientTimesheetdata] = useState(null);
  const [timeSheetData, setTimeSheetData] = useState(null);
  const [modalFor, setModalFor] = useState("HOME");
  const [helpModal, setHelpModal] = useState(false);

  // View modal states
  const [openIndividual, setOpenIndividual] = useState(false);

  // Crew
  const [openCrewForemanentry, setOpenCrewForemanentry] = useState(false);
  const [openCrewForeman, setOpencrewforeman] = useState(false);

  // Crew Clock In
  const [openGenerated, setOpengenerated] = useState(false);
  const [openEmployee, setOpenemployee] = useState(false);
  const [crewClockInClockOut, setCrewClockInClockOut] = useState(false);

  const [isRefresh, setIsrefresh] = useState(false);

  // Review timesheet
  const [openReview, setOpenreview] = useState(false);
  const [reviewData, setReviewdata] = useState({});

  const [newTemplate, setNewtemplate] = useState(false);
  const [detail, setDetail] = useState({});

  const {
    TEXT_MY_TIMESHEETS,
    TEXT_HOURS,
    TEXT_NOT_SUBMITTED_TIMESHEET,
    TEXT_FOREMAN_CREATED_TITLE,
    TEXT_EMPLOYEES,
    TEXT_JOBS,
    TEXT_ACTIVITIES
  } = ClientEnglishFallback?.ClientTimesheet(multiLanguageData?.ClientTimesheet || {});

  const { TEXT_ACTION_BE_UNDONE, TEXT_SURE_WANT_TO_DELETE_THIS_TIMESHEET } =
    ClientEnglishFallback?.DeletConfirmModal(multiLanguageData?.DeletConfirmModal || {});

  useEffect(() => {
    if (selectedClientData) {
      fetchClientTimesheet();
    } else {
      fetchClientTimesheetToApprove();
    }
  }, [currentTab, selectedClientData]);

  const fetchClientTimesheet = async () => {
    setIsLoading(true);
    try {
      const response = await Getrequestcall(
        GET_CLIENT_TIMESHEET_DASHBOARD + `/${selectedClientData?.ClientEmployeeId}`,
        loginData?.accessToken
      );
      if (response?.status === 200) {
        const resData = response?.data?.data ?? [];
        setTimesheetList([...resData]);
      }
    } catch (error) {
      console.error("Error fetching client timesheet:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchClientTimesheetToApprove = async () => {
    setIsLoading(true);
    try {
      const response = await Getrequestcall(
        FETCH_CLIENT_TIMESHEETS_TO_APPROVE + `/${selectedClientData?.ClientEmployeeId}`,
        loginData?.accessToken
      );
      if (response?.status === 200) {
        const resData = response?.data ?? [];
        setToApproveTimesheetList([...resData.data]);
        setToApproveCount(resData.nrOfRecords);
      }
    } catch (error) {
      console.error("Error fetching timesheets to approve:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteTimesheet = async (id) => {
    try {
      setIsLoading(true);
      const payload = {
        userId: loginData?.userInformation?.UserId,
        returnRecordError: true,
        softDelete: false,
        deleteList: [{ id: Number(id) }]
      };
      await Postrequestcall(DELETE_CLIENT_TIMESHEETS, payload, loginData?.accessToken);
      await fetchClientTimesheet();
    } catch (error) {
      console.error("Error deleting timesheet:", error);
      alert("Something went wrong. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteConfirm = () => {
    deleteTimesheet(deleteItem?.id);
    setDeletConfirmModal(false);
  };

  const viewTimesheet = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    setViewClientTimesheetdata(item);
    const isActivitiesPresent = item?.noOfActivities > 0;
    const isHoursPresent = item?.status !== "In Progress";
    const isInProgress = item?.status === "In Progress";
    switch (item?.type) {
      case TIMESHEET_TYPES.CREW:
        if (!isActivitiesPresent && isHoursPresent) {
          // console.log("setOpencrewforeman");
          setOpencrewforeman(true);
        } else if (isActivitiesPresent) {
          // console.log("setOpengenerated");
          setOpengenerated(true);
        } else if (!isActivitiesPresent && !isHoursPresent) {
          // console.log("setOpenCrewForemanentry");
          setOpenCrewForemanentry(true);
        }
        break;
      case TIMESHEET_TYPES.CREW_CLOCK_IN:
        if (isActivitiesPresent) {
          if (!isInProgress) {
            setOpengenerated(true);
            // console.log("setOpengenerated");
          } else {
            setIsrefresh(false);
            setOpenemployee(true);
            // console.log("setOpenemployee");
          }
        } else if (!isActivitiesPresent && !isInProgress) {
          setOpencrewforeman(true);
          // console.log("setOpencrewforeman");
        } else if (!isActivitiesPresent && isInProgress) {
          setCrewClockInClockOut(true);
          // console.log("setCrewClockInClockOut");
        }
        break;
      case TIMESHEET_TYPES.INDIVIDUAL:
        setOpenIndividual(true);
        break;
      case TIMESHEET_TYPES.INDIVIDUAL_CLOCK_IN:
        if (item?.status === TIMESHEET_STATUS.IN_REVIEW) {
          setOpenIndividual(true);
        } else {
          setTimeSheetData(item);
          setShowAddClientTimesheetModal(true);
          setModalFor("INDIVIDUAL-CLOCKIN");
        }
        break;
      default:
        break;
    }
  };

  const getTimesheetTypeInfo = (item) => {
    const { noOfEmployees, noOfJobs, noOfActivities } = item;

    if (noOfEmployees > 0) {
      return (
        <Stack>
          <Typography color="grey">{TEXT_EMPLOYEES}</Typography>
          <Typography>{noOfEmployees}</Typography>
        </Stack>
      );
    }

    if (noOfEmployees === 0 && noOfActivities > 0) {
      return (
        <Stack>
          <Typography color="grey">{TEXT_ACTIVITIES}</Typography>
          <Typography>{noOfActivities}</Typography>
        </Stack>
      );
    }

    return (
      <Stack>
        <Typography color="grey">{TEXT_JOBS}</Typography>
        <Typography>{noOfJobs}</Typography>
      </Stack>
    );
  };

  const getStatusChip = (item) => {
    if (item.totalHours === TIMESHEET_STATUS.IN_PROGRESS) {
      return null;
    }
    const { status, noOfActivities } = item;
    let chipStyle = null;
    switch (status) {
      case TIMESHEET_STATUS.REJECTED:
        chipStyle = {
          backgroundColor: COLORS.RED_LIGHT,
          color: COLORS.RED_DARK_TEXT
        };
        break;
      case TIMESHEET_STATUS.APPROVED:
        chipStyle = {
          backgroundColor: COLORS.GREEN_LIGHT,
          color: COLORS.GREEN_DARK_TEXT
        };
        break;
      case TIMESHEET_STATUS.IN_REVIEW:
        chipStyle = {
          backgroundColor: "#e4e4e4"
        };
        break;
      default:
        return null;
    }

    if (noOfActivities === 0) {
      return <Chip label={status} size="small" style={chipStyle} />;
    }
    return null;
  };

  const onSaveasTemplate = async (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const timesheetJobObject = {
        PageNr: 1,
        FullSearch: "",
        UserId: USER_ID,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientTimesheetId: item?.id
          }
        ]
      };
      const res = await Postrequestcall(FETCH_CLIENT_TIMESHEET_JOBS_V2, timesheetJobObject, TOKEN);
      if (res.status === 200) {
        setDetail(res?.data?.data?.[0]);
        setNewtemplate(true);
      }
    } catch (err) {
      console.log("onSaveasTemplate-> Error While Fetching Client Timesheet Jobs: ", err);
    } finally {
    }
  };

  const renderTimesheetCard = (item, index, isApprovalTab = false) => {
    const isInProgress =
      item.totalHours === TIMESHEET_STATUS.IN_PROGRESS ||
      item.status === TIMESHEET_STATUS.IN_PROGRESS;

    const isWorkPackageTS = item?.workpackageId > 0;
    return (
      <Stack
        key={index}
        onClick={(e) => !isApprovalTab && viewTimesheet(e, item)}
        sx={{
          cursor: !isApprovalTab ? "pointer" : "default",
          boxShadow: "none",
          padding: "10px",
          borderRadius: "10px",
          border: "1px solid #e4e4e4",
          backgroundColor:
            item?.status === "In Review"
              ? item?.noOfActivities > 0
                ? BILightGrey
                : "white"
              : item?.status === "In Progress"
                ? COLORS.LIGHT_YELLOW
                : BILightGrey
        }}>
        <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
          <Stack>
            <Typography fontWeight="bold">{moment(item?.date).format("MMMM DD, YYYY")}</Typography>
            {item?.clientJobCode && item?.clientJobName && (
              <Typography color="grey">
                {item.clientJobCode} - {item.clientJobName}
              </Typography>
            )}
          </Stack>
          {item.noOfActivities === 0 ? (
            <Stack flexDirection={"row"} gap={1}>
              {item.status === TIMESHEET_STATUS.IN_PROGRESS ? (
                <>
                  {!isWorkPackageTS && (<IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDeleteItem({ id: item?.id, fromIndexDB: item?.fromIndexDB });
                      setDeletConfirmModal(true);
                    }}>
                    <DeleteIcon />
                  </IconButton>)}

                  {item?.type?.includes("Crew") && (
                    <IconButton size="small" onClick={(e) => onSaveasTemplate(e, item)}>
                      <ContentCopyIcon
                        sx={{
                          height: "20px",
                          width: "20px"
                        }}
                      />
                    </IconButton>
                  )}
                </>
              ) : item?.type === "Crew Clock In" && item.noOfActivities === 0 ? (
                <IconButton size="small" onClick={(e) => onSaveasTemplate(e, item)}>
                  <ContentCopyIcon
                    sx={{
                      height: "20px",
                      width: "20px"
                    }}
                  />
                </IconButton>
              ) : (
                item?.type === "Crew" && (
                  <IconButton size="small" onClick={(e) => onSaveasTemplate(e, item)}>
                    <ContentCopyIcon
                      sx={{
                        height: "20px",
                        width: "20px"
                      }}
                    />
                  </IconButton>
                )
              )}
            </Stack>
          ) : (
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setHelpModal(true);
              }}
              size="small">
              <HelpIcon sx={{ color: "#000000" }} />
            </IconButton>
          )}
        </Stack>
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          marginTop="10px">
          <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
            {getTimesheetTypeInfo(item)}
            <Stack>
              <Typography color="grey">{TEXT_HOURS}</Typography>
              <Typography>{isInProgress ? "In Progress" : formatTime(item.totalHours)}</Typography>
            </Stack>
          </Stack>
          {getStatusChip(item)}
        </Stack>
      </Stack>
    );
  };

  const fabStyles = {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    background: clientAccentColor,
    color: "#fff",
    "&:hover": {
      background: clientAccentColor
    }
  };

  const Tabs = [
    {
      label: TEXT_MY_TIMESHEETS,
      value: 0,
      translateLabel: TEXT_MY_TIMESHEETS
    }
    // ,{
    //   label: `To Approve (${toApproveCount})`,
    //   value: 1
    // }
  ];

  return (
    <>
      <TabsComponent tabs={Tabs} setTabsValue={setCurrentTab} tabValue={currentTab} />
      <Stack
        style={{
          overflow: "scroll",
          height: "calc(100vh - 110px)",
          scrollbarWidth: "none",
          marginTop: "10px"
        }}>
        <>
          {isLoading ? (
            <Loader fullScreen={true} />
          ) : (
            <>
              {timesheetList?.length === 0 ? (
                <Stack alignItems="center" height={"90vh"} justifyContent="center">
                  <Typography color={BIGrey}>{TEXT_NOT_SUBMITTED_TIMESHEET}</Typography>
                </Stack>
              ) : (
                <Stack spacing={2}>
                  {currentTab === 0
                    ? timesheetList?.map((item, index) => renderTimesheetCard(item, index))
                    : toApproveTimesheetList?.map((item, index) =>
                      renderTimesheetCard(item, index, true)
                    )}
                </Stack>
              )}
              <Fab
                sx={fabStyles}
                onClick={() => {
                  setShowAddClientTimesheetModal(true);
                  setModalFor("HOME");
                }}>
                <AddIcon />
              </Fab>
            </>
          )}
        </>
      </Stack>

      {newTemplate && (
        <CrewTemplateForm
          timeSheetData={detail}
          from="CrewTimesheet"
          isOpen={newTemplate}
          onClose={() => {
            setNewtemplate(false);
          }}
          templateId={0}
        />
      )}

      {openCrewForemanentry && (
        <CrewTimesheetForemanEntry
          isOpen={openCrewForemanentry}
          clientTimesheetId={viewClientTimesheetdata?.id}
          onClose={() => {
            setOpenCrewForemanentry(false);
            fetchClientTimesheet();
          }}
        />
      )}

      {openIndividual && (
        <ClientTimesheetViewIndividual
          isOpen={openIndividual}
          reloadData={fetchClientTimesheet}
          onClose={() => setOpenIndividual(false)}
          item={viewClientTimesheetdata}
          isFor={viewClientTimesheetdata?.type}
        />
      )}

      <ClientViewEmployeeTimeSheet
        item={viewClientTimesheetdata}
        isOpen={openEmployee}
        setReviewdata={setReviewdata}
        onClose={
          isRefresh
            ? () => {
              setOpenemployee(false);
              fetchClientTimesheet();
            }
            : () => {
              setOpenemployee(false);
            }
        }
        setOpenreview={setOpenreview}
        setIsrefresh={setIsrefresh}
      />

      {openGenerated && (
        <ClientViewGeneratedTimesheet
          isOpen={openGenerated}
          onClose={() => setOpengenerated(false)}
          item={viewClientTimesheetdata}
          setHelpModal={setHelpModal}
        />
      )}

      <ClientViewCrewTimesheetForeman
        isOpen={openCrewForeman}
        onClose={() => setOpencrewforeman(false)}
        id={viewClientTimesheetdata?.id}
      />

      <CrewTimesheetEmployeeClockInClockOut
        isOpen={crewClockInClockOut}
        clientTimesheetId={viewClientTimesheetdata?.id}
        onClose={() => {
          setCrewClockInClockOut(false);
          fetchClientTimesheet();
        }}
      />

      {openReview && (
        <ReviewTimeSheet
          reviewData={reviewData}
          isOpen={openReview}
          reloadData={fetchClientTimesheet}
          onClose={() => setOpenreview(false)}
        />
      )}

      <DeletConfirmModal
        isOpen={deletConfirmModal}
        onClose={() => setDeletConfirmModal(false)}
        onConfirm={handleDeleteConfirm}
        title={TEXT_ACTION_BE_UNDONE}
        heading={TEXT_SURE_WANT_TO_DELETE_THIS_TIMESHEET}
      />

      <ConfirmModal
        isOpen={helpModal}
        onClose={() => setHelpModal(false)}
        isHelpModal
        title={TEXT_FOREMAN_CREATED_TITLE}
      />

      {showAddClientTimesheetModal && (
        <ClientTimesheetAddModal
          setViewClientTimesheetdata={setViewClientTimesheetdata}
          showAddClientTimesheetModal={showAddClientTimesheetModal}
          FOR={modalFor}
          InitialTimesheetData={viewClientTimesheetdata}
          reloadData={fetchClientTimesheet}
          timeSheetData={timeSheetData}
          setTimeSheetData={setTimeSheetData}
          handleClose={() => {
            setShowAddClientTimesheetModal(false);
            setViewClientTimesheetdata(null);
          }}
        />
      )}
    </>
  );
};

export default ClientTimesheets;
